<template>
    <div class="search-bar">
        <loading :flag="loadingFlag"></loading>
        <div class="search-row">
            <div class="input-box" style="width: 430px;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="iconfont icon-location"></i>
                    </div>
                    <div class="search-input search-location" ref="origin">
                        <div>{{$t('destination')}}</div>
                        <input
                            :placeholder="$t('hotel_search_pl')"
                            autocomplete="new-password"
                            @input="showHotels"
                            v-model="desName"
                            @click="toggleShow"
                            readonly
                        />
                        <search-hotel
                            v-show="showHotel"
                            :is-loading="showHotelLoading"
                            :data="result"
                            @menu-select="selectOrigin"
                        ></search-hotel>
                        <hot-city @menu-select="selectOrigin" v-show="showHotCity"></hot-city>
                    </div>
                </div>
            </div>
            <div class="input-box" style="width: 337px;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="el-input__icon el-icon-date"></i>
                    </div>
                    <div class="search-input search-date">
                        <div>{{$t('check_in_date')}}</div>
                        <input type="text" readonly v-model="hotelDater.startDate" />
                        <!-- <el-date-picker v-model="startDate" type="date" :picker-options="startOption"
                        :clearable="false" :editable="false" value-format="yyyy-MM-dd"></el-date-picker>-->
                        <i class="iconfont icon-arrow-down"></i>
                    </div>
                    <div class="search-input search-date">
                        <div>{{$t('check_out_date')}}</div>
                        <input type="text" readonly v-model="hotelDater.endDate" />
                        <!-- <el-date-picker v-model="endDate" type="date" :picker-options="endOption"
                        :clearable="false" :editable="false" value-format="yyyy-MM-dd"></el-date-picker>-->
                        <i class="iconfont icon-arrow-down"></i>
                    </div>
                    <el-date-picker
                        v-model="dater"
                        type="daterange"
                        :picker-options="startOption"
                        :clearable="false"
                        :editable="false"
                        class="el-daterange"
                        value-format="yyyy-MM-dd"
                        @change="changeDater"
                    ></el-date-picker>
                </div>
            </div>
            <div class="input-box" style="flex: 1;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="iconfont icon-user-group"></i>
                    </div>
                    <div class="search-input" ref="pMenu">
                        <div>{{$t('passenger_hotel')}}</div>
                        <input
                            type="text"
                            class="input-item"
                            v-model="persion"
                            readonly="readonly"
                            @click="showPMenu = !showPMenu"
                        />
                        <persion-menu :show="showPMenu" @i-select="pMenuSelect"></persion-menu>
                    </div>
                </div>
            </div>
            <button
                class="btn btn-warning btn-block search-button"
                @click="searchContent"
            >{{$t('search')}}</button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import InputNumber from "@/components/Inputnumber.vue";
import Loading from "@/components/Loading.vue";
import PersionMenu from "@/views/AirTicket/components/GuestsMenu";
import { debounce, linkTo } from "@/lib/utils";
import HotCity from "./HotCItyList";
import SearchHotel from "./SearchLocation.vue";
import { mapGetters } from "vuex";
import { searchHotelByHotelGtag, searchCityByHotelGtag } from "@/lib/gtag.js";

export default {
    name: "hotelSearch",
    components: {
        InputNumber,
        Loading,
        PersionMenu,
        SearchHotel,
        HotCity
    },
    data() {
        return {
            city: "",
            cityData: "",
            loadingFlag: false,
            dater: new Date(),
            startOption: {
                disabledDate: function(nowDate) {
                    return moment().isAfter(nowDate, "days");
                }
            },
            personData: {
                room: 1,
                Adults: 1,
                Children: 0,
                Cots: 0,
                Age: []
            },
            desName: "", //目的地名称
            persion: `1 ${this.$t("room")}，1 ${this.$t("adult")}`, //人数及结构
            showPMenu: false,
            result: null,
            showHotel: false,
            showHotCity: false,
            isKeywordNull: false,
            showHotelLoading: false,
            cityCode: ""
        };
    },
    computed: {
        ...mapGetters(["hotelDes", "hotelDater"])
    },
    watch: {
        hotelDes: {
            immediate: true,
            handler: function(val) {
                this.desName = val.name || val.city_name;
            }
        }
    },
    methods: {
        //乘客选择
        pMenuSelect(data) {
            this.personData = data;
            this.persion = `${data.room} ${this.$t("room")}，${data.room *
                data.Adults} ${this.$t("adult")}`;
            if (data.Children) {
                this.persion += `，${data.room * data.Children} ${
                    data.room * data.Children >= 2
                        ? this.$t("children")
                        : this.$t("child")
                }`;
            }
        },
        toggleShow(e) {
            //解除readonly模式
            e.target.removeAttribute("readonly");

            if (this.showHotel) {
                this.showHotCity = false;
            } else {
                this.showHotCity = !this.showHotCity;
            }
            this.showHotel = false;
        },
        showHotels() {
            this.showHotCity = false;
            this.result = null;
            if (this.desName.trim() !== "") {
                this.showHotel = true;
                this.showHotelLoading = true;
                debounce(this.search, 1000)("search", this.desName);
            } else {
                this.showHotel = false;
                this.showHotelLoading = false;
            }
        },
        changeDater(date) {
            this.$store.dispatch("searchHotelData", {
                des: this.hotelDes,
                dater: {
                    startDate: date[0],
                    endDate: date[1]
                }
            });
        },

        /**
         * 搜索列表选择事件
         * @param {String} name 酒店、区域或城市名
         * @param {*} city 搜索数据
         */
        selectOrigin(name, city) {
            this.desName = name;
            this.$store.dispatch("searchHotelData", {
                des: city,
                dater: {
                    startDate: this.hotelDater.startDate,
                    endDate: this.hotelDater.endDate
                }
            });
            this.$store.dispatch("updateHistoryCityList", city);
            this.showHotel = false;
            this.showHotCity = false;
        },
        search(type, city) {
            this.$req
                .get("v1_9/hotelSearch", {
                    search: city
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        this.result = data.data;
                    }
                })
                .finally(() => {
                    this.showHotelLoading = false;
                });
        },
        changeAddress(con) {
            this.showHotel = false;
            this.city = con.name;
            this.$local.set("hotel_city", con);
        },

        /**
         * 搜索按钮触发
         */
        searchContent() {
            this.showPMenu = false;
            if (!this.desName || this.desName.length === 0) {
                this.$msg.error(this.$t("msg_hotel"));
                return;
            }

            let hotelCode = this.hotelDes.hotelItemCode;

            //埋点
            if (hotelCode) {
                searchHotelByHotelGtag({
                    入住日期: this.hotelDater.startDate,
                    退房日期: this.hotelDater.endDate,
                    酒店名称: this.hotelDes.hotelName,
                    酒店ID: hotelCode,
                    入住人数: this.persion
                });
            } else {
                searchCityByHotelGtag({
                    入住日期: this.hotelDater.startDate,
                    退房日期: this.hotelDater.endDate,
                    城市名称: this.hotelDes.name,
                    "城市/区域编码":
                        this.hotelDes.cityCode ||
                        this.hotelDes.city_code ||
                        "zone",
                    入住人数: this.persion
                });
            }

            //搜索框存在于三个页面，首页、酒店列表及酒店详情
            if (!this.$route) {
                /* 处于首页 */
                if (hotelCode) {
                    /* 存在code, 打开酒店详情 */
                    linkTo(
                        `/hotel/detail/${hotelCode}/main?startdate=${this.hotelDater.startDate}&enddate=${this.hotelDater.endDate}&room=${this.personData.room}`
                    );
                } else {
                    /* 打开酒店列表 */
                    linkTo(
                        `/hotel/list/${this.hotelDes.cityCode ||
                            this.hotelDes.city_code ||
                            "zone"}`
                    );
                }
            } else {
                let thisRoute = this.$route.name;
                this.$emit("search");
            }
        }
    }
};
</script>

<style>
.hotel-container .search-row .input-box:first-child {
    width: 337px !important;
}
.input-box .el-input__inner {
    background-color: transparent;
    height: 25px;
    border: none;
    padding-left: 0;
    color: #fff;
    font-size: 16px;
}
.input-box .el-date-editor {
    width: 100%;
}
.input-box .el-input__prefix {
    display: none;
}
</style>


<style lang="scss" scoped>
.search-bar {
    position: relative;
    padding: 30px 0 20px 0;
}
.search-row {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .input-box {
        box-sizing: border-box;
        padding: 3px;

        .input-box-inner {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 68px;
            padding-right: 10px;
            border-radius: 2px;
            background: #f6f6f6;
            position: relative;

            .el-daterange {
                position: absolute;
                height: 30px;
                top: 27px;
                left: 20px;
                opacity: 0;
            }

            .iconfont {
                color: #767676;
            }

            .icon-container {
                padding: 18px 10px 0;
                width: 45px;
                box-sizing: border-box;

                i {
                    font-size: 24px;
                    color: #767676;
                }
            }
        }

        .reverse-icon {
            padding: 18px 10px 0;
            width: 50px;
            box-sizing: border-box;

            .iconfont {
                font-size: 12px;
            }
        }

        .search-date {
            height: 43px;
            position: relative;

            input {
                height: 60%;
            }

            .iconfont {
                position: absolute;
                top: 19px;
                right: 10px;
                // z-index: -1;
            }
        }

        .search-input {
            color: #767676;
            flex: 1;
            position: relative;

            div {
                font-size: 12px;
                margin-bottom: 5px;
            }

            input {
                background-color: transparent;
                color: #767676;
                box-sizing: border-box;
                width: 100%;
                &::-webkit-input-placeholder {
                    color: rgba(118, 118, 118, 0.6);
                }
            }
        }
    }
}
.search-button {
    width: 160px;
    height: 60px;
    font-size: 24px;
    font-weight: 500;
    position: absolute;
    border-radius: 50px;
    top: 130px;
    box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Searchbar.vue